<template lang="pug">
#app
    topbar

    navigation(v-if="$store.getters.loggedIn")

    .alert.alert-warning.text-center(v-if="showRenewCTA")
        | Ihre gewählte Laufzeit ist abgelaufen. Hinzufügen und Bearbeiten sind nicht mehr möglich.
        |
        a.ml-2(
            href="mailto:support@luftverbundrechner.de?subject=Bitte%20meine%20Laufzeit%20verlängern&body=Sehr%20geehrte%20Damen%20und%20Herren,%0D%0A%0D%0Abitte%20verlängern%20Sie%20meine%20Laufzeit%20für%20[1%20|%202%20|%203]%20Jahre%20zu%20den%20aktuellen%20Konditionen.%0D%0A%0D%0AFreundliche Grüße%0D%0A%0D%0A[Ihr%20Name%20und%20Signatur]"
        )
            | &raquo; Jetzt Ihre Laufzeit verlängern! &laquo;

    .alert.text-center.alert-dismissible(v-if="!!alert.message", :class="`alert-${alert.type}`")
        | {{ alert.message }}
        button.close(@click="$store.dispatch('alert/clear')") &times;

    router-view
</template>

<script>
import Topbar from '@/components/Topbar.vue'
import Navigation from '@/components/Navigation.vue'

export default {
    components: {
        Topbar,
        Navigation
    },
    computed: {
        alert () {
            return this.$store.getters.alert
        },
        showRenewCTA () {
            return this.$store.getters.loggedIn && !this.$store.getters.accountActive
        }
    },
    watch: {
        $route (to, from) {
            // clear alert on location change
            this.$store.dispatch('alert/clear')
        }
    }
}
</script>

<style lang="scss">
@import "@/assets/scss/main.scss";
</style>
